import Calendar from "./calendar-payment";
import Notify from "./../notify";

export default class PaymentObject {
    constructor() {

        this.userData = {
            name: "",
            phone: "",
            email: "",
            passport: ""
        };

        this.currentLocationId = null;
        this.windowPay = "";
        this.textPrice = "руб";
        this.ajaxUrl = "/themes/ahtilahti/ajax/object-pay.php";
        this.modalId = "modal-object-more";
        this.modal = null;
        this.errorModalId = "page-modal-error";
        this.errorModal = null;
        this.checkSavePassport = false;
        this.validateStep3Flag = false;
        this.form = "payment-object";
        this.allowedExtensionsFiles = [
            '.pdf',
            '.PDF',
            '.PNG',
            '.jpg',
            '.JPG',
            '.png',
            '.JPEG',
            '.jpeg'
        ];

        this.navigation = {
            step0: "payment-step-0",
            step1: "payment-step-1",
            step2: "payment-step-2",
            step3: "payment-step-3",
            step4: "payment-step-4",
        };

        this.controllElements = {
            stepButton0: "payment-step-next-0",
            stepPrevButton0: "payment-step-prev-0",
            stepButton1: "payment-step-next-1",
            stepPrevButton1: "payment-step-prev-1",
            stepContainer0: "payment-step-container-0",
            stepContainer1: "payment-step-container-1",
            stepContainer2: "payment-step-container-2",
            stepContainer3: "payment-step-container-3",
            stepContainer4: "payment-step-container-4",
        };

        this.resultObject = {};

        this.blockResultText = "detail-block";
        this.minArendCountDates = 2;
        this.maxArendCountDates = 30;
        this.maxArendCounObject = 5;

        if (!$("#payment-step-container-0").length) {
            this.calendar = new Calendar("container-date");
            this.formatter = new Intl.DateTimeFormat("ru");
            this.calendar.init();
            this.watchCalendarRangeFill();
        }

    }

    showStep0() {
        $("#" + this.navigation.step0).removeClass("sect_dark");
        $("#" + this.controllElements.stepContainer0).removeClass("hide");
        $("#" + this.controllElements.stepContainer0).show();
    }

    hideStep0() {
        $("#" + this.navigation.step0).addClass("sect_dark");
        $("#" + this.controllElements.stepContainer0).hide();
        // 
    }

    showStep1() {
        if (!this.calendar) {

            this.calendar = new Calendar("container-date");
            this.formatter = new Intl.DateTimeFormat("ru");
            this.calendar.init();
            this.watchCalendarRangeFill();
        }
        $("#" + this.navigation.step1).removeClass("sect_dark");
        $("#" + this.controllElements.stepContainer1).removeClass("hide");
        $("#" + this.controllElements.stepContainer1).show();

        if ($("#" + this.controllElements.stepContainer0).length) {

            this.createButtonsNavigationStep1();
        }


    }
    hideStep1() {
        $("#" + this.navigation.step1).addClass("sect_dark");

        $("#" + this.controllElements.stepContainer1).hide();
        $('#' + this.blockResultText).hide();
    }

    showStep2() {
        $("#" + this.navigation.step2).removeClass("sect_dark");
        if (!this.bookTransition) {

            this.renderingObjects();
        }

        $("#" + this.controllElements.stepContainer2).show();
        // $(".cert-container").removeClass("hide");
        $('#' + this.blockResultText).show();
        this.createButtonsNavigationStep2();

    }

    hideStep2() {
        $("#" + this.navigation.step2).addClass("sect_dark");
        $("#" + this.controllElements.stepContainer2).hide();
        $('#' + this.blockResultText).hide();

    }

    showStep3() {
        $("#" + this.navigation.step3).removeClass("sect_dark");


        this.initPersonalDate();

        $("#" + this.controllElements.stepContainer3).show();


        this.createButtonsNavigationStep3();
    }

    hideStep3() {
        $("#" + this.navigation.step3).addClass("sect_dark");
        $("#" + this.controllElements.stepContainer3).hide();



    }

    showStep4() {
        $("#" + this.navigation.step4).removeClass("sect_dark");
        this.initResultPage();
        $("#" + this.controllElements.stepContainer4).show();


        this.createButtonsNavigationStep4();
    }

    hideStep4() {
        $("#" + this.navigation.step4).addClass("sect_dark");
        $("#" + this.controllElements.stepContainer4).hide();



    }

    openWindowPay() {
        this.windowPay = window.open();
    }

    createButtonsNavigationStep2() {
        if (!this.navigationButtonsIsus2) {
            $("<div />", {
                class: "grid-x align-justify",
                html: "<div class='cell medium-shrink'><a id='prev-button1' href='#' class='button hollow expanded'><i class='fa fa-chevron-left'></i> Предыдущий шаг</a></div>" +
                    "<div class='cell medium-shrink'><a  id='next-button3' href='#' class='hide button hollow expanded'>Следующий шаг <i class='fa fa-chevron-right'></i> </a></div>"
            }).appendTo("#" + this.controllElements.stepContainer2);
            this.navigationButtonsIsus2 = true;
        }

    }
    createButtonsNavigationStep3() {
        if (!this.navigationButtonsIsus3) {
            $("<div />", {
                class: "grid-x align-justify",
                html: "<div class='cell medium-shrink'><a id='prev-button' href='#' class='button hollow expanded'><i class='fa fa-chevron-left'></i> Предыдущий шаг</a></div>" +
                    "<div class='cell medium-shrink'><a  id='next-button' href='#' class='button hollow expanded'>Следующий шаг <i class='fa fa-chevron-right'></i> </a></div>"
            }).appendTo("#" + this.controllElements.stepContainer3);
            this.navigationButtonsIsus3 = true;
        }

    }

    createButtonsNavigationStep4() {
        if (!this.navigationButtonsIsuse4) {
            $("<div />", {
                class: "grid-x align-justify",
                html: "<div class='cell medium-shrink'><a id='prev-button4' href='#' class='button hollow expanded'><i class='fa fa-chevron-left'></i> Предыдущий шаг</a></div>" +
                    "<div class='cell medium-shrink'><a  id='object-pay' href='#' class='button  expanded'>Оплатить </a></div>"
            }).appendTo("#" + this.controllElements.stepContainer4);
            this.navigationButtonsIsuse4 = true;
        }

    }

    createButtonsNavigationStep1() {
        if (!this.navigationButtonsIsuse1) {
            $("<div />", {
                class: "grid-x align-justify",
                html: "<div class='cell medium-shrink'><a id='prev-button-step-0' href='#' class='button hollow expanded'><i class='fa fa-chevron-left'></i> Предыдущий шаг</a></div>"

            }).appendTo("#" + this.controllElements.stepContainer1);
            this.navigationButtonsIsuse1 = true;
        }

    }


    initEventButtonsNavigationSteps() {
        let instance = this;
        $(document).on("click", "#prev-button", function(e) {
            instance.bookTransition = true;
            e.preventDefault();
            instance.hideStep3();
            instance.showStep2();


        });



        $(document).on("click", "#prev-button-step-0", function(e) {
            e.preventDefault();
            instance.hideStep1();
            instance.showStep0();

        });


        $(document).on("click", "#prev-button1", function(e) {
            e.preventDefault();
            instance.hideStep2();
            instance.showStep1();
            $("#object-list-container").empty();
            $("#next-button3").addClass("hide");
            instance.bookTransition = false;
        });




        $(document).on("click", "#next-button3", function(e) {
            e.preventDefault();

            instance.hideStep2();
            instance.showStep3();



        });


        $(document).on("click", "#next-button", function(e) {
            e.preventDefault();
            instance.validateStep3();

            if (!instance.validateStep3Flag) {
                instance.hideStep3();
                instance.showStep4();
            }


        });


        $(document).on("click", "#next-button", function(e) {
            e.preventDefault();
            instance.validateStep3();

            if (!instance.validateStep3Flag) {
                instance.hideStep3();
                instance.showStep4();
            }


        });

        $(document).on("click", "#prev-button4", function(e) {
            e.preventDefault();
            instance.hideStep4();
            instance.showStep3();
        });

        $(document).on("click", "#object-pay", function(e) {
            e.preventDefault();
            instance.openWindowPay();
            instance.orderCreate();

        });

    }

    orderCreate() {
        let instance = this;
        let personalDate = this.userData;
        let objectListIds = [];
        let datesList = this.calendar.fullDates.selectedDates;
        for (let obj in this.resultObject) {
            objectListIds.push(this.resultObject[obj].fields["id"]);
        }


        let formDate = new FormData($('#payment-object')[0]);

        formDate.append("personal", this.userData);
        formDate.append("checkDoc", this.checkSavePassport);
        formDate.append("objectsIds", objectListIds);
        formDate.append("datesList", datesList);
        formDate.append("action", "order_create");

        $.each($("input[type='file']"), function(element) {
            $.each($(this)[0].files, function(i, file) {
                formDate.append('file[]', file);
            });

        });

        $.ajax({
            method: "POST",
            url: "/themes/ahtilahti/ajax/object-create-pay.php",
            async: false,
            cache: false,
            contentType: false,
            processData: false,
            data: formDate,
            success: function(response) {

                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);
                if (res.success && res.payUrl) {
                    instance.sucessOrderTemplate();

                    instance.windowPay.location.href = res.payUrl;

                } else {
                    instance.windowPay.close();
                    new Notify(res.error, "alert");
                }
            },

            error(xhr, status, error) {
                new Notify(error, "alert");
            },
        });

    }
    sucessOrderTemplate() {
        let container = document.createElement("div");
        container.classList.add("grid-y");
        container.innerHTML =
            " <div class='cell text-center' style='margin-top:auto;margin-bottom:auto;'>" +
            "<br>" +
            "<div class='flex-container align-center'>" +
            "<div style='max-width: 80ch;'><h1>Спасибо! Ваше снаряжение успешно забронировано</h1>" +
            "<div class='sect lead'>В случае неоплаты заказа в течение 15 минут бронь будет автоматически снята</div>" +
            "<div class='sect sect_dark'>Пожалуйста, оплатите заказ сейчас или его придётся оформлять заново</div>" +
            "</div></div><br>" +
            " </div>";
        $("#payment-main-content").html(container);
    }

    validateStep3() {
        // Валидация
        this.validateStep3Flag = false;
        let inputs = $("#" + this.controllElements.stepContainer3).find('input[type="text"],input[type="email"], input[type="phone"],textarea');
        if (inputs.length > 0) {
            for (let i of inputs) {
                if ($(i).attr("data-required") == "Y") {
                    if (!$(i).val().trim() || $(i).val().length == 0) {
                        $(i).addClass("callout alert");

                        this.validateStep3Flag = true;
                    } else {
                        $(i).removeClass("callout alert");
                    }
                }
                let name = $(i).attr("name");
                let value = $(i).val().trim();
                this.userData[name] = value;
            }
        }

        if ($("[name='phone']").inputmask("isComplete")) {
            $("[name='phone']").removeClass("callout alert");
        } else {
            this.validateStep3Flag = true;
            $("[name='phone']").addClass("callout alert");
        }

        if (this.emailValidate($("[name='email']").val())) {
            $("[name='email']").removeClass("callout alert");
        } else {
            this.validateStep3Flag = true;
            $("[name='email']").addClass("callout alert");
        }
        //  проверка чекбоксов
        let agreeOffer = $("[name='agree-offer']");
        let agreeConf = $("[name='agree-conf']");

        if (!agreeOffer.prop("checked")) {
            this.validateStep3Flag = true;

            if ($("#alert-agree-offer").length <= 0) {
                agreeOffer
                    .parent()
                    .before(
                        "<p  class='callout alert' id='alert-agree-offer'>Необходимо принять условия оферты</p>"
                    );
            }
        } else {
            $("#alert-agree-offer").detach();
        }
        if (!agreeConf.prop("checked")) {
            this.validateStep3Flag = true;
            if ($("#alert-agree-conf").length <= 0) {
                agreeConf
                    .parent()
                    .before(
                        "<p  class='callout alert' id='alert-agree-conf'>Необходимо согласие с политикой конфиденциальности</p>"
                    );
            }
        } else {
            $("#alert-agree-conf").detach();
        }



    }



    renderingObjects() {
        // 
        if (!$("#object-list-container").length) {
            $("<div/>", {
                id: 'object-list-container',
                class: "object-list-container",
                html: "<p class='sect_dark no-margin'>Снаряжение, доступное на выбранные даты: </p>",
            }).appendTo("#" + this.controllElements.stepContainer2);
        }
        for (let o in this.objects) {
            let preview = "/themes/ahtilahti/i/photo.svg";
            if (this.objects[o].fields["photo"].length > 0) {
                preview = this.objects[o].fields["photo"][0]["fields"]["file"];
            }
            let summArendForPeriod = 0;
            let summZalogs = 0;

            for (let price in this.objects[o].fields["dates_and_price"]) {
                summArendForPeriod += parseInt(this.objects[o].fields["dates_and_price"][price]["fields"]["repeat_price"]);
            }


            if (this.objects[o].fields["count_day_for_discound"] != null && this.calendar.fullDates.selectedDates.length >= this.objects[o].fields["count_day_for_discound"]) {
                //   percent_for_discound
                if (this.objects[o].fields["percent_for_discound"] != 0 && this.objects[o].fields["percent_for_discound"] && (this.objects[o].fields["count_day_for_discound"] && this.objects[o].fields["count_day_for_discound"] != 0)) {

                    summArendForPeriod = parseInt(summArendForPeriod) - (parseInt(summArendForPeriod) / 100 * parseInt(this.objects[o].fields["percent_for_discound"]));

                }

            }


            summZalogs += parseInt(this.objects[o].fields["zalog_for_save_doc"]) + parseInt(this.objects[o].fields["zalog_for_save"]) + parseInt(this.objects[o].fields["zalog_for_clear"]);



            $("<div/>", {
                id: "obj-" + this.objects[o].fields["id"],
                dataId: this.objects[o].fields["id"],
                class: "card",
                dataSerial: o,
                html: "<div class='card-section grid-x grid-padding-x align-middle'>" +
                    "<div class='cell auto medium-2 medium-offset-1  small-12  card-img-detail'><a href='#' title='Подробнее' class='show-more'><img src='" + preview + "' ></a></div>" +
                    "<div class='cell medium-auto  text-center  small-12 '> <div class='event-meta'>Наименование:</div><div class='lead'>" + this.objects[o].fields["name"] + "</div></div>" +
                    "<div class='cell small-12 medium-auto text-center '> <div class='event-meta'>Стоимость аренды:</div><div class='lead'>" + summArendForPeriod + "&nbsp;" + this.textPrice + "</div></div>" +
                    "<div class='cell small-12 medium-offset-0 medium-auto text-center  '><div class='event-meta'>Сумма залогов:</div><div class='lead'>" + summZalogs + "&nbsp;" + this.textPrice + "</div></div>" +
                    "<div class='cell small-24 medium-auto text-center '><button type='button' class='button   button__add__object'>Выбрать</button></div>" +
                    "</div>"
            }).appendTo("#object-list-container");
            // 

        }


    }
    checkCalendarDates() {
        let checkFlagSuccess = true;
        if (this.calendar.fullDates.dates.length > 1) {
            if (this.calendar.fullDates.selectedDates.length < this.minArendCountDates) {
                new Notify("Минимальный период аренды " + this.minArendCountDates + " дня", "alert");
                checkFlagSuccess = false;
            }
            if (this.calendar.fullDates.selectedDates.length > this.maxArendCountDates) {
                new Notify("Максимальный  период аренды " + this.maxArendCountDates + " дней", "alert");
                checkFlagSuccess = false;
            }

        } else {
            checkFlagSuccess = false;
        }
        return checkFlagSuccess;
    }

    declOfNum(number, titles) {
        let cases = [2, 0, 1, 1, 1, 2];
        return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    }

    showBlockResult() {
        $("#" + this.blockResultText).show();
    }
    hideBlockResult() {
        $("#" + this.blockResultText).hide();
    }
    emptyBlockResult() {
        $("#" + this.blockResultText).empty();
    }

    loadArendObjects() {

        if (this.calendar.fullDates.selectedDates.length > 0) {
            let instance = this;
            $.ajax({
                method: "POST",
                url: this.ajaxUrl,
                async: false,
                data: {
                    action: "getArendList",
                    data: {
                        dates: this.calendar.fullDates.selectedDates,
                        location: this.currentLocationId,
                    },
                },
                success: function(response) {

                    let res;
                    typeof response === "string" ?
                        (res = $.parseJSON(response)) :
                        (res = response);

                    if (res.success == true) {
                        instance.objects = res.objects;
                    } else {
                        instance.objects = {};
                        new Notify(res.message, "alert");
                    }


                },

                error(xhr, status, error) {
                    console.log(error);
                },
            });
        }
    }

    setPeriodResultBock() {
        let countDates = this.calendar.fullDates.selectedDates.length;
        let textday = this.declOfNum(countDates, ['день', 'дня', 'дней']);
        let firstDate = this.formatter.format(new Date(new Date().setTime(this.calendar.fullDates.selectedDates[0])));
        let lastDate = this.formatter.format(new Date(new Date().setTime(this.calendar.fullDates.selectedDates[countDates - 1])));
        $("#" + this.blockResultText).html("<div id='arend-date-period' class='grid-x arend-date-period'><div class='cell medium-12'><span class='sect_dark'>Даты аренды:</span> <br> c " + firstDate + " по " + lastDate + ", итого " + countDates + " " + textday + "</div></div> ");
        //    
    }

    initModalMore() {
        if (!this.modal) {
            this.modal = new Foundation.Reveal($("#" + this.modalId));
        }
    }

    initErrorModal() {
        if (!this.errorModal) {
            this.errorModal = new Foundation.Reveal($("#" + this.errorModalId));
        }
    }


    initBookButton() {
        if (!$("#book-container-button").length) {
            $("#block-selected-objects").append("<div id='book-container-button' class='text-right cell medium-auto'><button type='button' id='book-button' class='button'>Забронировать</button></div>");
        }

        $("#next-button3").removeClass("hide");

    }
    removeBookButton() {
        $("#book-container-button").detach();
        $("#next-button3").addClass("hide");
    }

    initEventBookButtonClick() {
        let instance = this;
        $(document).on("click", "#book-button", function(e) {
            e.preventDefault();
            instance.bookTransition = true;
            instance.hideStep2();
            instance.showStep3();

        });
    }

    watchCalendarRangeFill() {
        let instance = this;

        // $(document).on("click", ".calendar-date-disabled--hover", function(e) {

        //     e.preventDefault();
        //     let flag = instance.checkCalendarDates();

        //     console.log("кликаем");
        //     console.log(flag);
        //     // if (flag) {

        //     //     instance.showBlockResult();
        //     //     instance.setPeriodResultBock();
        //     //     instance.loadArendObjects();
        //     //     if (instance.objects && Object.keys(instance.objects).length > 0) {
        //     //         instance.hideStep1();
        //     //         instance.showStep2();
        //     //     }

        //     // } else {
        //     //     instance.emptyBlockResult();
        //     //     instance.hideBlockResult();
        //     // }


        // });

        $(document).on("click", "#calendar-apply", function(e) {
            e.preventDefault();
            // console.log("click");


            let flag = instance.checkCalendarDates();


            if (flag) {
                instance.showBlockResult();
                instance.setPeriodResultBock();
                instance.loadArendObjects();
                if (instance.objects && Object.keys(instance.objects).length > 0) {
                    instance.hideStep1();
                    instance.showStep2();
                }
                // console.log("flag true");
            } else {
                // console.log("flag false");
                instance.emptyBlockResult();
                instance.hideBlockResult();
            }


        });

    }

    initEventClickMore() {
        if (!this.clickIsUse) {
            let instance = this;
            $(document).on("click", ".show-more", function(e) {
                let id = $(this).closest(".card").attr("dataid");
                $("#modal-object-more-container").load("/themes/ahtilahti/ajax/object-pay.php", { data: { action: "get-object-more", id: id } });

                e.preventDefault();
                instance.modal.open();
            });
            this.clickIsUse = true;
        }
    }

    emailValidate(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    renderResultObjects() {
        if (Object.keys(this.resultObject).length > 0) {
            let resultSumm = 0;
            let resultZalogSumm = 0;
            let resultZalogClearSumm = 0;



            let html = "<div class='sect_dark'>Выбранное снаряжение:</div><div class='table-scroll'><table class='unstriped'><thead> <tr><td>Наименование объекта</td><td>Стоимость аренды за выбранный период</td><td>Залог за сохранность</td><td>Залог за чистоту</td></td></tr></thead>";
            for (let o in this.resultObject) {
                let summArendForPeriod = 0;

                for (let price in this.resultObject[o].fields["dates_and_price"]) {
                    summArendForPeriod += parseInt(this.resultObject[o].fields["dates_and_price"][price]["fields"]["repeat_price"]);
                }

                if (this.resultObject[o].fields["count_day_for_discound"] != null && (this.calendar.fullDates.selectedDates.length >= this.resultObject[o].fields["count_day_for_discound"])) {
                    //   percent_for_discound
                    if (this.resultObject[o].fields["percent_for_discound"] != 0 && this.resultObject[o].fields["percent_for_discound"] && (this.resultObject[o].fields["count_day_for_discound"] && this.resultObject[o].fields["count_day_for_discound"] != 0)) {
                        summArendForPeriod = parseInt(summArendForPeriod) - ((parseInt(summArendForPeriod) / 100 * parseInt(this.resultObject[o].fields["percent_for_discound"])));

                    }

                }
                // 

                resultSumm += parseInt(summArendForPeriod);

                let zalogPassport = parseInt(this.resultObject[o].fields["zalog_for_save"]);
                if (this.checkSavePassport == true) {
                    zalogPassport = parseInt(this.resultObject[o].fields["zalog_for_save_doc"]);
                }
                resultZalogSumm += zalogPassport;
                resultZalogClearSumm += parseInt(this.resultObject[o].fields["zalog_for_clear"])

                html += "<tr>" +
                    "<td>" + this.resultObject[o].fields["name"] + "</td><td>" + summArendForPeriod + "&nbsp;" + this.textPrice + "</td> <td>" + zalogPassport + "&nbsp;" + this.textPrice + "</td><td>" + this.resultObject[o].fields["zalog_for_clear"] + "&nbsp;" + this.textPrice + "</td></tr>"
            }
            let checked = "";
            if (this.checkSavePassport) {
                checked = "checked";
            }
            html += "</table></div>" +
                "<div  class='grid-x grid-padding-x' id='checkbox-save-passport-container'>" +
                "<div id='checkbox-save-passport' style='margin-bottom: 20px' class='cell medium-12'> <label class='flex-container align-top'><input name='passport-agree' " + checked + "  type='checkbox' >" +
                "<span class='flex-child-auto'>Я оставлю свой паспорт на сохранение в ООО “Ахтилахти” на период аренды (сумма залога за сохранность уменьшится)</span></label></div>" +
                "<div id='result-table' class='cell medium-auto text-right'><div class=''><p>" + "Итого за аренду: " + resultSumm + "&nbsp;" + this.textPrice + "" +
                "&nbsp;&nbsp;<span data-allow-overlap='true' data-click-open='false' data-position='left' data-alignment='center'  class='general-infotip has-tip tip-top left' data-allow-html='true' aria-haspopup='true' type='button' data-tooltip tabindex='1' title='Это стоимость аренды, её нужно полностью оплатить сейчас'><i class='fas fa-lg fa-info-circle'></i></span>" +
                "</p><p>Итого залог за сохранность: " + resultZalogSumm + "&nbsp;" + this.textPrice + "" +
                "&nbsp;&nbsp;<span data-allow-overlap='true'  data-click-open='false' data-position='left' data-alignment='center' class='general-infotip has-tip tip-top left' data-allow-html='true' aria-haspopup='true' type='button' data-tooltip tabindex='1' title='Этот залог нужно внести наличными администратору станции проката в день получения снаряжения в аренду'><i class='fas fa-lg fa-info-circle'></i></span>" +
                "</p><p>Итого залог за чистоту: " + resultZalogClearSumm + "&nbsp;" + this.textPrice + "" +
                "&nbsp;&nbsp;<span  data-allow-overlap='true'  data-click-open='false' data-position='left' data-alignment='center' class='general-infotip has-tip tip-top left' data-allow-html='true' aria-haspopup='true' type='button' data-tooltip tabindex='1'  title='Этот залог нужно внести наличными администратору станции проката в день получения снаряжения в аренду'><i class='fas fa-lg fa-info-circle'></i></span>" +
                "</p><hr></div></div>"
            "</div>";
            if ($("#block-selected-objects").length) {

                $("#block-selected-objects").html(html);

            } else {

                $("<div />", {
                    id: "block-selected-objects",
                    html: html
                }).appendTo("#" + this.blockResultText);
            }

            this.initBookButton();

        } else {
            if ($("#block-selected-objects").length) {
                $("#block-selected-objects").detach();
                $("#checkbox-save-passport").detach();
            }
        }

        this.initTooltips();

    }
    initTooltips() {



        $.each($(".has-tip"), function(index) {
            if (!$(this).attr("data-toggle")) {
                new Foundation.Tooltip($(this));
            }
        });

        //

    }
    initEventPassportAgree() {
        let instance = this;
        $(document).on("change", "input[name='passport-agree']", function(e) {
            if ($(this).prop("checked")) {
                instance.checkSavePassport = true;
            } else {
                instance.checkSavePassport = false;
            }

            instance.renderResultObjects();
        });
    }
    addObject(serial) {

        this.resultObject[serial] = this.objects[serial];

        this.renderResultObjects();

    }

    removeObject(serial) {
        delete this.resultObject[serial];
        if (Object.keys(this.resultObject).length <= 0) {
            this.removeBookButton();
        }

        this.renderResultObjects();
    }

    initEventAddObject() {
        if (!this.clickAddObject) {
            let instance = this;
            $(document).on("click", ".button__add__object", function(e) {
                e.preventDefault();
                let serial = $(this).closest(".card").attr("dataserial");

                if (Object.keys(instance.resultObject).length >= instance.maxArendCounObject) {
                    instance.errorModal.open();
                } else {
                    instance.addObject(serial);
                    $(this).html("Убрать");
                    $(this).addClass("alert");
                    $(this).removeClass("button__add__object");
                    $(this).addClass("button__remove__object");
                }

            });

            $(document).on("click", ".button__remove__object", function(e) {
                e.preventDefault();
                let serial = $(this).closest(".card").attr("dataserial");
                instance.removeObject(serial);
                $(this).html("Выбрать");
                $(this).removeClass("alert");
                $(this).removeClass("button__remove__object");
                $(this).addClass("button__add__object");
            });

            // 

            this.clickAddObject = true;
        }
    }

    initPersonalDate() {
        if (!$("#personal-data-container").length) {
            $("<div />", {
                html: "<div class='grid-x'>" +
                    "<div class='cell medium-16'>" +
                    "<div class='grid-x grdi-padding-x align-middle'>" +
                    "<div class='cell small-18'>" +
                    "<label>ФИО*<span class='flex-container'><input type='text' id='fio' maxlength='100'  name='name' data-required='Y' placeholder='Фамилия, Имя, Отчество'></span></label>" +
                    "</div>" +
                    "</div>" +
                    "<div class='grid-x grdi-padding-x align-middle'>" +
                    "<div class='cell small-18'>" +
                    "<label>Телефон*<span class='flex-container'><input type='text'   name='phone' data-required='Y' placeholder='8 (000) 000 00 00'></span></label>" +
                    "</div>" +
                    "</div>" +
                    "<div class='grid-x grdi-padding-x align-middle'>" +
                    "<div class='cell small-18'>" +
                    "<label>E-mail*<span class='flex-container'><input  maxlength='254' type='text'  name='email' data-required='Y' placeholder='E-mail'></span></label>" +
                    "</div>" +
                    "</div>" +

                    "<div class='grid-x grdi-padding-x align-middle'>" +
                    "<div class='cell small-18'>" +
                    "<label>Паспортные данные*<span class='flex-container'><textarea rows='6'  name='passport' data-required='Y' placeholder='паспорт РФ СЕРИЯ, НОМЕР, ВЫДАН КЕМ, ВЫДАН КОГДА, регистрация по паспорту: город, улица, дом, корпус, квартира'></textarea></span></label>" +
                    "</div>" +
                    "<div class='cell auto'>" +
                    "&nbsp;&nbsp;<span class='general-infotip has-tip tip-top top' data-allow-html='true' aria-haspopup='true' type='button' data-tooltip tabindex='1' title='Эти данные нужны для подтверждения личности и оформления документов на аренду. <a target=&quot;_blank&quot; rel=&quot;noopener noreferrer&quot; href=&quot;https://ahtilahti.ru/privacy&quot; class=&quot;footer__labs&quot;>Наша политика конфиденциальности</a>' ><i class='fas fa-lg fa-info-circle'></i></span>" +
                    "</div>" +
                    "</div>" +
                    "<div class='grid-x grdi-padding-x align-middle'>" +
                    "<div class='cell small-18'>" +
                    "<label>Паспорт в формате *.pdf, *.png и *.jpeg  &nbsp;&nbsp;<span class='general-infotip has-tip tip-top top' data-allow-html='true' aria-haspopup='true' type='button' data-tooltip tabindex='1' title='Скан или фото 2, 3 (основные данные) и 5, 6 (регистрация) страниц паспорта гражданина РФ' ><i class='fas fa-lg fa-info-circle'></i></span></label>" +
                    "<div class='grid-x grid-padding-x small-up-1 medium-up-3 files-block align-bottom'>" +
                    "<div class='cell'><div class='download-file-name'></div><label for='downloadFile1' class='button expanded'>Загрузить скан</label><span class='flex-container'><input class='upload-scan show-for-sr' id='downloadFile1' type='file' /></span></div>" +
                    "<div class='cell'><div class='download-file-name'></div><label for='downloadFile2' class='button expanded'>Загрузить скан</label><span class='flex-container'><input class='upload-scan show-for-sr' id='downloadFile2' type='file' /></span></div>" +
                    "<div class='cell'><div class='download-file-name'></div><label for='downloadFile3' class='button expanded'>Загрузить скан</label><span class='flex-container'><input class='upload-scan show-for-sr' id='downloadFile3' type='file' /></span></div>" +
                    "</div>" +
                    "<label class='flex-container align-top'><input name='agree-offer' data-required='Y' type='checkbox' checked='checked'/>" +
                    "<span class='flex-child-auto'>Я прочитал и принимаю " +
                    "<a target='_blank' rel='noopener noreferrer' href='https://ahtilahti.ru/oferta/'>условия оферты</a>" +
                    "</span></label>" +
                    "<label class='flex-container align-top'><input name='agree-conf' data-required='Y' type='checkbox' checked='checked'/>" +
                    "<span class='flex-child-auto'>Я прочитал и соглашаюсь с " +
                    "<a target='_blank' rel='noopener noreferrer' href='https://ahtilahti.ru/privacy/'>политикой конфиденциальности</a>" +
                    "</span></label>" +
                    "</div>" +
                    "</div>",
                id: "personal-data-container"
            }).appendTo("#" + this.controllElements.stepContainer3);
            this.initTooltips();
            $("[name='phone']").inputmask({
                mask: "8 (999) 999 99 99",
            });
            $("#fio").on("input", function() {
                $(this).val(
                    $(this)
                    .val()
                    .replace(/^[^А-Яа-яЁёA-Za-z\-\s]/, "")
                );
            });

        }

    }
    initResultPage() {
        let countDates = this.calendar.fullDates.selectedDates.length;
        let textday = this.declOfNum(countDates, ['день', 'дня', 'дней']);
        let firstDate = this.formatter.format(new Date(new Date().setTime(this.calendar.fullDates.selectedDates[0])));
        let lastDate = this.formatter.format(new Date(new Date().setTime(this.calendar.fullDates.selectedDates[countDates - 1])));

        let htmlObjects = "";
        let resultPice = 0;
        let zalogForSave = 0;
        let zalogForClear = 0;
        // console.log("resultObject");

        // console.log(this.resultObject);

        for (let o in this.resultObject) {
            let summArendForPeriod = 0;
            for (let i in this.resultObject[o].fields["dates_and_price"]) {
                summArendForPeriod += parseInt(this.resultObject[o].fields["dates_and_price"][i].fields["repeat_price"]);

            }


            if (this.resultObject[o].fields["count_day_for_discound"] != null && (this.calendar.fullDates.selectedDates.length >= this.resultObject[o].fields["count_day_for_discound"])) {
                //   percent_for_discound
                if (this.resultObject[o].fields["percent_for_discound"] != 0 && this.resultObject[o].fields["percent_for_discound"] && (this.resultObject[o].fields["count_day_for_discound"] && this.resultObject[o].fields["count_day_for_discound"] != 0)) {
                    summArendForPeriod = parseInt(summArendForPeriod) - ((parseInt(summArendForPeriod) / 100 * parseInt(this.resultObject[o].fields["percent_for_discound"])));

                }

            }



            resultPice += summArendForPeriod;
            zalogForClear += parseInt(this.resultObject[o].fields["zalog_for_clear"]);
            zalogForSave += this.checkSavePassport ? parseInt(this.resultObject[o].fields["zalog_for_save_doc"]) : parseInt(this.resultObject[o].fields["zalog_for_save"]);
            htmlObjects += "<p>" + (parseInt(o) + parseInt(1)) + ":" + "&nbsp;" + this.resultObject[o].fields["name"] + " - " + this.resultObject[o].fields["dates_and_price"].length + " " + this.declOfNum(this.resultObject[o].fields["dates_and_price"].length, ['день', 'дня', 'дней']) + " - " + summArendForPeriod + "&nbsp;" + this.textPrice + "</p>";
        }
        // test

        let html = "<div class='sect'><strong>Контакты</strong></div>" +
            "<div class='sect_dark'>Фио заказчика:</div><p>" + this.userData.name + "</p>" +
            "<div class='sect_dark'>Телефон заказчика:</div> <p>" + this.userData.phone + "</p>" +
            "<div class='sect_dark'>Email заказчика:</div> <p>" + this.userData.email + "</p>" +
            "<div class='sect_dark'>Паспортные данные:</div> <p>" + this.userData.passport + "</p>" +
            "<div class='sect'><strong>Аренда</strong></div>" +
            "<div class='sect_dark'>Период аренды:</div> <p> c " + firstDate + " по " + lastDate + ", итого " + countDates + " " + textday + "</p>" +
            htmlObjects +
            "<div class='sect_dark'>Стоимость Итого за весь заказ:</div><p>" + resultPice + "&nbsp;" + this.textPrice + "&nbsp;<span class='general-infotip has-tip tip-top top' data-allow-html='true' aria-haspopup='true' type='button' data-tooltip tabindex='1' title='К оплате сейчас'><i class='fas fa-lg fa-info-circle'></i></span></p>" +
            "<div class='sect_dark'>Залог за сохранность за весь заказ:</div><p>" + zalogForSave + "&nbsp;" + this.textPrice + "&nbsp;<span class='general-infotip has-tip tip-top top' data-allow-html='true' aria-haspopup='true' type='button' data-tooltip tabindex='1' title='К оплате наличными при получении'><i class='fas fa-lg fa-info-circle'></i></span></p>" +
            "<div class='sect_dark'>Залог за чистоту за весь заказ:</div><p>" + zalogForClear + "&nbsp;" + this.textPrice + "&nbsp;<span class='general-infotip has-tip tip-top top' data-allow-html='true' aria-haspopup='true' type='button' data-tooltip tabindex='1' title='К оплате наличными при получении'><i class='fas fa-lg fa-info-circle'></i></span></p>" +
            "<div class='sect'><strong>Совершая оплату Арендатор (Клиент, Заказчик):</strong></div>" +
            "<p>Соглашается с <a href='https://ahtilahti.ru/privacy/' target='_blank'>политикой конфиденциальности</a> и даёт согласие ООО “Ахтилахти” на обработку персональных данных</p>" +
            "<p>Безоговорочно принимает <a href='https://ahtilahti.ru/oferta_arenda/' target='_blank'>условия оферты на услуги аренды туристического снаряжения </a> </p>";
        if ($("#page-result").length) {
            $("#page-result").html(html);
        } else {
            $("<div />", {
                html: html,
                id: "page-result",

            }).appendTo("#" + this.controllElements.stepContainer4);
        }
        this.initTooltips();

    }


    initEventsDownloadsFile() {
        let instance = this;
        $(document).on("change", ".upload-scan", function() {

            let fileName = $(this).val().split('/').pop().split('\\').pop();
            let file = fileName.replace(/\.[^/.]+$/, "");
            let resFile = null;
            let endName = file.slice(file.length - 4);
            let startName = file.slice(0, 4);
            let delimiter = fileName.lastIndexOf('.');
            let extension = fileName.substr(delimiter);
            let size = (this.files[0].size / 1000).toFixed(1);


            if ($.inArray(extension, instance.allowedExtensionsFiles) != -1) {

                if (size <= 100) {

                    if (file.length > 10) {
                        if (startName == endName) {
                            resFile = startName + extension;
                        } else {
                            resFile = startName + "..." + endName + extension;
                        }

                    } else {
                        resFile = fileName;
                    }
                    let value = resFile;

                    if (value) {
                        $(this).closest(".cell").find(".download-file-name").html(value + "&nbsp;&nbsp;&nbsp;<span class='file-close delete-file'><i class='fas fa-times'></i></span>");

                    } else {
                        $(this).closest(".cell").find(".download-file-name").html("<span class='text-alert'>Ошибка.</span>");
                        let id = $(this).closest(".cell").find(".upload-scan").attr("id");
                        document.getElementById(id).value = "";
                    }

                } else {
                    new Notify("Файл не должен превышать 100 КБ", 'alert');
                    let id = $(this).closest(".cell").find(".upload-scan").attr("id");
                    document.getElementById(id).value = "";
                }

            } else {


                new Notify("Недопустимое расширение файла", 'alert');
                let id = $(this).closest(".cell").find(".upload-scan").attr("id");
                document.getElementById(id).value = "";

            }



        });

        $(document).on("click", ".file-close", function(e) {
            e.preventDefault();
            let id = $(this).closest(".cell").find(".upload-scan").attr("id");
            document.getElementById(id).value = "";
            $(this).closest(".cell").find(".download-file-name").empty();

        });

    }
    initLocations() {
        let instance = this;
        $(document).on("click", ".button__add__location", function(e) {
            e.preventDefault();
            instance.currentLocationId = $(this).closest(".location-item").attr("dataid");
            instance.hideStep0();
            instance.showStep1();
        });
    }

    init() {
        this.initLocations();

        this.initModalMore();
        this.initErrorModal();
        this.initEventClickMore();
        this.initEventPassportAgree();
        this.initEventBookButtonClick();
        this.initEventButtonsNavigationSteps();
        this.initEventsDownloadsFile();
        this.initEventAddObject();
    }

}


(function() {

    if ($("#payment-object").length) {
        const pay = new PaymentObject();
        pay.init();
    }

})(jQuery);
//